import React from 'react'

import type { SpaceProps } from '../../../../themes'
import { renderChildrenWithProps } from '../../../../utils/renderChildrenWithProps'
import type { BadgeProps } from '../../../Badge'
import { Container } from './styles'

type BadgeElement =
  | React.ReactElement<BadgeProps>
  | null
  | undefined
  | boolean
  | ''

export interface CardContentBadgeListProps extends SpaceProps {
  className?: string
  children: BadgeElement | BadgeElement[]
}

export const CardContentBadgeList = ({
  className,
  children,
  ...spaceProps
}: CardContentBadgeListProps) => {
  return (
    <Container className={className} {...spaceProps}>
      {renderChildrenWithProps(children, {
        // Fix badge size
        size: 'md',
        tabletSize: 'md',
      })}
    </Container>
  )
}
